/**
 * Hebrew guide body paragraphs by topic id.
 * Tab titles stay in guidesHe (translations.js); article text uses this map.
 */
const guidesParagraphsHe = {
  welcome: [
    "Mu Beginning הוא שרת פרטי Season 6 Episode 3 עם משחק MU קלאסי, מערכות מותאמות ופיצ'רים לנוחות.",
    "במדורים האלה תלמדו על מחלקות, ריסטים, VIP, מבוכים, יצירת Fenrir, אירועים ועוד — כל הערכים תואמים לנתוני ה־GameServer החיים.",
    "הצטרפו לדיסקורד להודעות, תמיכה ועזרה מהקהילה.",
  ],

  "game-options": [
    "פתחו את Game Settings מתפריט System / Escape במשחק (Option / Game Settings). כותרת החלון היא “Game Settings”.",
    "ההגדרות נשמרות מקומית תחת Data\\Custom\\GameOption\\GameOption.xml ונשארות גם אחרי הפעלה מחדש של הקליינט.",
    "יש שתי לשוניות עיקריות: Game ו־Graphics. בהן שולטים בעזרי קרב, תצוגת ממשק, ביצועים, רזולוציה, FPS, סאונד ומה מוצג על המסך.",
    "טיפ: אם המשחק מרגיש איטי במפות עמוסות או באירועים — הורידו Graphics Mode, הפחיתו FPS, או הפעילו Hide (שחקנים/מפלצות/כנפיים) לשיפור ביצועים.",
  ],

  "game-options-game-tab": [
    "Drop Item / Show Name Item — בחרו “Always Show item Names” או “Do Not Show”. כשמופעל Always Show, שמות פריטים על הקרקע נשארים גלויים בלי לעבור עליהם.",
    "Auto HP — Turn On / Turn Off. כשמופעל, הקליינט מבקש מהשרת התנהגות של השבת HP אוטומטית (שימושי בציד).",
    "Auto Attack — Turn On / Turn Off. מפעיל עזרת תקיפה אוטומטית / סגנון Auto-PK. השתמשו בזהירות ושמרו על חוקי השרת.",
    "Show HP Bar — Always Show או Do Not Show. שולט אם מוצגות פסי HP מעל דמויות/מפלצות.",
    "Show Character Name — Always Show או Do Not Show. שולט אם שמות הדמויות נשארים גלויים על המסך.",
    "VSync — נועל את הצגת הפריימים לקצב הרענון של המסך כדי להפחית tearing (עלול להוריד FPS במחשבים חלשים).",
    "Effect 15 — מדליק/מכבה שכבת אפקט ויזואלי נוספת (אפשר לכבות לביצועים).",
    "Screen Camera — מדליק/מכבה מצב מצלמה מותאם אישית שלנו.",
  ],

  "game-options-graphics-tab": [
    "Mode Graphics — מצבים: Low, Medium, High, Ultra. שינוי המצב מתאים אוטומטית צללים, זוהר, אפקטי Excellent ודגלי איכות קשורים.",
    "FPS Limit — בחרו 60 / 120 / 144 / 175 / 200 / Unlimited. FPS גבוה יותר חלק יותר אבל דורש מחשב חזק יותר. Unlimited מסיר את התקרה הרכה.",
    "Option Game (הסתרת רינדור) — Hide Wings, Hide Weapon, Hide Texture, Hide Monster, Hide Terrain, Hide Player. מפשט את מה שמצויר ומשפר FPS במלחמות/אירועים.",
    "On/Off Music — הפעלה/כיבוי מוזיקת רקע. סליידר Music Volume (0–100) שולט בעוצמה כשהמוזיקה פועלת.",
    "On/Off World Sound — הפעלה/כיבוי צלילי עולם/סביבה (מכות מפלצות, אווירת מפה וכו').",
    "Resolution — בחרו רזולוציה מהרשימה (גללו אם צריך). הקליינט מחיל את הגודל החדש ומרענן את הממשק.",
    "Font Size — גודל גופן 13 / 14 / 15. גופן גדול יותר עוזר לקריאות במסכים ברזולוציה גבוהה.",
    "מומלץ: התחילו עם High + 60/120 FPS; אם נופלים פריימים ב־Castle Siege או פלישות — עברו ל־Medium/Low והסתירו שחקנים/מפלצות אחרים.",
  ],

  helper: [
    "ה־MU Helper מסייע בציד אוטומטי, שיקויים והגדרות איסוף.",
    "הגדירו בזהירות ושמרו על חוקי משחק הוגן — שימוש לרעה עלול להוביל לעונשים.",
    "אפשרויות המשחק (Auto Attack / Auto HP) עובדות יחד עם הגדרות ה־Helper — בדקו את שתיהן כדי שהדמות תתנהג כמצופה.",
  ],

  interface: [
    "השתמשו באינבנטורי, מחסן, פארטי, קווסטים וחלון Event Time כדי לשחק ביעילות.",
    "פתחו Event Time במשחק לראות ספירות לאחור ל־Blood Castle, פלישות ועוד — פאנל Upcoming Events באתר משתמש באותם לוחות זמנים.",
    "לחצן Push-to-talk לצ'אט קולי הוא F1 (ראו Systems → Voice Chat). Game Settings מטפל בגרפיקה/סאונד/ממשק; קיצורי מקשים כמו F1 נפרדים.",
  ],

  dw: [
    "מחלקת קסם לטווח. סטאט הנזק העיקרי הוא Energy; Vitality לשרידות.",
    "חזקה בגלים של PvE ובתוכן פארטי עם כישורי AoE. שימו דגש על מיקום וניהול מאנה.",
    "מסלול ההתפתחות כולל Soul Master ו־Grand Master (Season 6).",
  ],

  dk: [
    "לוחם קרוב לחזית. Strength לנזק, Agility למהירות התקפה/הגנה, Vitality ל־HP.",
    "מצוין ל־PvP ולטנקינג באירועים כמו Blood Castle ו־Chaos Castle.",
    "מתפתח דרך Blade Knight ו־Blade Master.",
  ],

  fe: [
    "היברידית תמיכה ו־DPS לטווח. בילד Agility לנזק קשת; Energy לריפוי/באפים.",
    "מאוד מוערכת בפארטי בזכות באפים וקיימות. חזקה ב־PvE ובתפקידי תמיכה ב־Castle Siege.",
    "מתפתחת דרך Muse Elf ו־High Elf.",
  ],

  mg: [
    "היבריד לוחם־קוסם. יכול להשתמש בחרבות ובקסם; לרוב היברידי Strength/Energy.",
    "גמיש לקרב קרוב ולקסמים לטווח. אול־ראונדר חזק לאירועים ולפארם.",
    "לא עובר את אותו מסלול קווסט 2nd/3rd כמו מחלקות ההתחלה — בדקו מדריכי קווסט במשחק.",
  ],

  dl: [
    "מחלקה מבוססת Command עם חיות מחמד וכישורי מנהיגות פארטי. Leadership (Command) הוא סטאט מרכזי.",
    "חזק ב־PvP ובקרבות גדולים. משתמש ב־Dark Horse / Dark Raven ובסטים מיוחדים ל־DL.",
    "דורש השקעה נכונה ב־Leadership ליעילות הכישורים.",
  ],

  su: [
    "מחלקת זימון קסם עם קללות, ספרים וחיות זימון. Energy הוא סטאט הנזק העיקרי.",
    "מצטיין בשליטה לטווח בינוני/ארוך וב־PvE. למדו כישורי ספרים וניהול זימונים מוקדם.",
    "מתפתח דרך Bloody Summoner ו־Dimension Master.",
  ],

  rf: [
    "אמן לחימה לטווח קרוב עם כפפות וכישורי RF מיוחדים. Strength ו־Vitality הם הליבה.",
    "פרץ גבוה וניידות ב־PvP; פארם חזק כשיש גיר.",
    "מתפתח דרך Fist Master. אין Grow Lancer (GL) בשרת הזה.",
  ],

  "battle-pass": [
    "ה־Battle Pass שלנו רץ במחזורי עונה של 90 יום. מתקדמים בהשלמת קווסטים יומיים/שבועיים ובצבירת רמות Battle Pass (עד רמה 50).",
    "יש שני מסלולים: Free (לכולם) ו־Premium (שדרוג בתשלום עם תגמולים טובים יותר).",
    "מסלול Premium עולה 600 WCoin. אפשר גם לקנות רמות Battle Pass מוגבלות ב־WCoin (200 WCoin לרמה, עד 2 רכישות ביום).",
    "התגמולים כוללים תכשיטים, קופסאות Kundun ותגמולי Premium בלעדיים (כולל חיות מחמד ברמות Premium גבוהות).",
    "הישארו מחוברים והשלימו קווסטי אירועים/הריגות/תכשיטים שמופיעים בחלון ה־Battle Pass כדי להתקדם מהר יותר.",
  ],

  dungeons: [
    "ב־Mu Beginning יש קטלוג מבוכים מותאם (NPC) עם כניסות יומיות. איפוס יומי: 08:00 שעון השרת.",
    "VIP מעלה את מגבלת הכניסות היומיות: Normal 1 / Bronze 2 / Silver 3 / Gold 4 (לפי כללי ה־VIP).",
    "פארטי מאותה IP בתוך מבוכים חסום.",
    "Blood Castle Dungeon — 4 דרגות לפי ריסט (0–15 / 16–25 / 26–35 / 36–50), ~15 דק', עד 10/יום. פארם: תגמולי EXP גבוהים.",
    "Chaos Castle Dungeon — 4 דרגות, ~10 דק', 10/יום. פארם: חבילות Jewel of Chaos / Bless / Soul / Life / Creation / Guardian.",
    "Devil Square Dungeon — 4 דרגות, ~20 דק', 10/יום. פארם: Gemstone, Jewel of Harmony, Lower Refine Stone.",
    "Nightmare Dungeon (Battle of Nightmare) — T1–T4, ~20 דק', 10/יום. פארם: EXP + Beginning Boxes.",
    "Kanturu Dungeon (Battle of Maya) — T1–T4, ~45 דק', 5/יום. פארם: חומרי Fenrir — Splinter of Armor, Bless of Guardian, Claw of Beast.",
    "Imperial Guardian — דרגות קושי 0–3, ~55 דק', 10/יום. Master EXP מופעל במבוך הזה.",
  ],

  vip: [
    "קנו VIP במשחק עם מקש End (Custom Buy VIP). כל חבילה ל־30 יום.",
    "VIP Bronze — +10% Experience, +10% Drop. מחיר: 300 Credits.",
    "VIP Silver — +20% Experience, +20% Drop. מחיר: 600 Credits.",
    "VIP Gold — +30% Experience, +30% Drop. מחיר: 1000 Credits.",
    "VIP גבוה יותר משפר גם חלק משיעורי ההצלחה בקראפט (למשל Fenrir Mix) ואת מגבלות הכניסה היומיות למבוכים.",
    "בונוסי EXP/Drop ברמת חשבון מדרגות VIP מצטברים עם רייטי השרת לפי הגדרות ה־GameServer.",
  ],

  "fenrir-mix": [
    "יוצרים Fenrir שלב־אחר־שלב ב־Chaos Machine / Fenrir Mix. שיעורי ההצלחה עולים עם VIP (Normal / Bronze / Silver / Gold).",
    "שלב 1 — Fragment of Horn: Bless×10, Soul×10, Chaos×10, Creation×10, Life×10, Splinter of Armor×20, Bless of Guardian×20 + 100,000,000 Zen. הצלחה: 70% / 73% / 76% / 80%.",
    "שלב 2 — Broken Horn: תכשיטים×20 מכל סוג (Bless/Soul/Chaos/Creation/Life), Claw of Beast×20, Fragment of Horn×5 + 500,000,000 Zen. הצלחה: 50% / 55% / 60% / 65%.",
    "שלב 3 — Horn of Fenrir (Red): תכשיטים×30 מכל סוג + Broken Horn×1 + 1,000,000,000 Zen. הצלחה: 30% / 35% / 40% / 45%.",
    "שדרוג — Blue Fenrir: Red Fenrir + Soul×90 + Bless×90 + Chaos×60 + Life×60 + 10,000,000 Zen. הצלחה: 70% / 75% / 80% / 85%.",
    "שדרוג — Black Fenrir: Blue Fenrir + Soul×90 + Bless×90 + Chaos×60 + Creation×60 + 10,000,000 Zen. הצלחה: 70% / 75% / 80% / 85%.",
    "שדרוג — Gold Fenrir: Black Fenrir + Blue Fenrir. הצלחה: 60% / 70% / 80% / 90%.",
    "חבילות תכשיטים (10/20/30) יכולות להחליף תכשיטים מוערמים. פארמו Splinter / Bless of Guardian / Claw בעיקר מ־Kanturu Dungeon (Battle of Maya).",
  ],

  reset: [
    "פקודה: /reset (גם Auto-Reset מופעל). רמה נדרשת: 400. אחרי ריסט חוזרים לרמה 1 ב־Lorencia.",
    "מקסימום ריסטים לפני Grand Reset: 50.",
    "תגמול נקודות לפי מספר ריסט (אותה טבלה לכל VIP): ריסט 1–4 = 500 · ריסט 5 = 1000 · ריסט 10 = 1200 · ריסט 15 = 1400 · ריסט 20 = 1600 · ריסט 25 = 1800 · ריסט 30 = 2000 · ריסט 35 = 2200 · ריסט 40 = 2400 · ריסט 45 = 2600 · ריסט 50 = 2800.",
    "עלות Zen עולה עם מספר הריסט (ממיליונים בודדים בהתחלה עד ~1.5B בריסט 50 לפני Grand Reset). אחרי Grand Reset עלויות ה־Zen בערך מוכפלות (עד תקרה של 2,000,000,000).",
    "נקודות סטאט מריסטים מתווספות לפי טבלת הריסט — תכננו את הבילד לפני שמוציאים נקודות.",
  ],

  "grand-reset": [
    "פקודה: /greset (Master Reset).",
    "דרישה: 50 ריסטים הושלמו.",
    "עלות: 2,000,000,000 Zen.",
    "תגמול: 15,000 נקודות ריסט. אחרי Grand Reset מונה הריסטים חוזר ל־0 וניתן לטפס שוב בסולם.",
    "מגבלת שרת: מקסימום Grand Reset (Master Reset) אחד.",
  ],

  voice: [
    "צ'אט קולי לפי קרבה מופעל ב־Mu Beginning — דברו עם שחקנים קרובים דרך המיקרופון.",
    "מקש Push-to-talk: F1 (החזיקו כדי לדבר).",
    "רדיוס קול: 50. זמין לחשבונות Normal, VIP ו־GM.",
    "השתמשו במיקרופון/אוזניות תקינים ב־Windows, ואז החזיקו F1 במשחק ליד שחקנים אחרים.",
  ],

  quests: [
    "בשרת שלנו רצות במקביל כמה מערכות קווסטים:",
    "Quest System (Daily) — קווסטי הריגה/פארם (למשל עכבישים, גובלינים ומפות גבוהות יותר). פתחו את ממשק ה־Quest System למטרות ותגמולים נוכחיים.",
    "Quest NPC — NPC מותאם מסוג “Quest” (ID 600) במפות שונות לקווסטי הריגה/איסוף.",
    "Quest World / Gens — NPCs מסוג Shadow Phantom Soldier ו־Gens steward מטפלים בקווסטי התקדמות עולם/גנס.",
    "קווסטי מחלקה קלאסיים — Sebina the Priestess, Marlon ו־Apostle Devin ל־2nd/3rd class (לפי הדמות).",
    "קווסטי Elf Soldier / חיילים קלאסיים מופיעים בשרשרת הקווסטים הסטנדרטית של MU לפי המחלקה — עקבו אחרי דיאלוג ה־NPC במשחק.",
    "ה־Battle Pass מוסיף גם קווסטים יומיים/שבועיים הקשורים לאירועים, הריגות ואיסוף תכשיטים.",
  ],

  market: [
    "ה־Market הוא מערכת המסחר בין שחקנים — מפרסמים פריטים למכירה כדי שאחרים יקנו גם כשאתם אופליין.",
    "אתם בוחרים את משך הפרסום בימים. מקסימום: 30 יום.",
    "חל מס על המוכר לפי סוג הפריט (בערך 5–15% לפי קטגוריה).",
    "פרסומים שפגו יכולים להישמר למוכר אך להיות מוסתרים מקונים לפי הגדרות ה־Market — אספו חזרה פריטים שלא נמכרו.",
  ],

  "expanded-inventory": [
    "Expanded Inventory פותח מקום אינבנטורי נוסף באמצעות הפריט Magic Backpack.",
    "פריט: Magic Backpack (section 14, index 162).",
    "משך: 30 יום לכל שימוש בפריט הפתיחה.",
    "השתמשו בו כשהאינבנטורי הראשי מלא בסשני פארם ארוכים או בלוט מאירועים.",
  ],

  "online-bonus": [
    "הישארו אונליין כדי לקבל תגמולים אוטומטיים.",
    "מרווח: כל 60 דקות של זמן אונליין.",
    "תגמול: 1 Credit לכל מרווח.",
    "תנאי: להישאר מחוברים ל־GameServer; הטיימר מתקדם כשהדמות אונליין. ניתוק עוצר את ההתקדמות לתשלום הבא.",
  ],

  spots: [
    "התחילו במפות ההתחלה Lorencia / Noria / Devias, ואז עברו למפות גבוהות יותר כשהרמה והגיר משתפרים.",
    "השתמשו בציד פארטי, Online Bonus, VIP EXP ומבוכים כדי להאיץ ריסטים מוקדמים.",
    "Kanturu Dungeon חשוב בהמשך לחומרי Fenrir; מבוכי Chaos/Devil Square עוזרים להכנסת תכשיטים.",
  ],

  progression: [
    "1) הגיעו לרמה 400 והתחילו ריסטים · 2) פתחו VIP אם אתם משחקים יומיומית · 3) השתמשו במבוכים ל־EXP/תכשיטים · 4) טפסו ל־50 ריסטים · 5) Grand Reset לבוסט נקודות גדול · 6) צרו Fenrir כשהחומרים מוכנים.",
    "בדקו Commands ו־Event Time באופן קבוע כדי לא לפספס חלונות תגמול חינמיים.",
  ],

  "blood-castle": [
    "היכנסו בחלון הפתיחה, נקו מפלצות והשלימו את יעד הטירה לתגמולים.",
    "זמין גם כמופע מבוך יומי מדורג עם תגמולי EXP גדולים.",
  ],

  "devil-square": [
    "שרדו גלי מפלצות בתוך Devil Square לניסיון ולוט.",
    "גרסת המבוך מתמקדת בתגמולי תכשיטים/חומרי ריפיין.",
  ],

  "chaos-castle": [
    "אירוע הישרדות PvE בתוך Chaos Castle. נקו מפלצות והישארו בחיים לתגמולי תכשיטים.",
    "דרגות המבוך מתאימות לטווח הריסטים שלכם.",
  ],

  kanturu: [
    "תוכן אירוע Kanturu וקרבות Maya/Kanturu הקשורים.",
    "Kanturu Dungeon הוא פארם עיקרי לחומרי יצירת Fenrir.",
  ],

  kalima: [
    "אירוע Kalima Lord Kundun. הכינו שיקויים ופארטי יציב לחלון הבוס.",
  ],

  imperial: [
    "ריצות Imperial Guardian מתוזמנות עם כמה דרגות קושי. צפו לריצות ארוכות (~55 דק' בצורת מבוך) ול־Master EXP בהגדרות המבוך שלנו.",
  ],

  illusion: [
    "אירוע קבוצתי עם יעדי relic. הצטרפו כש־Event Time מציג Illusion Temple פתוח.",
  ],

  invasions: [
    "פלישות מתוזמנות מזמנות בוסים במפות שונות. בדקו Event Time לזימון הבא.",
    "כולל: Skeleton King, Red Dragon, Golden Invasion, White Wizard, Pouch of Blessing, White Rabbit, Fire Flame Ghost, Medusa, Ferea, Nix, God of Darkness, Core Magriffy, Lord Silvestre, Protector of Acheron, Evomon, Chicken, Horse, Goat, Monkey, Goblin, Silent Invasion, Golden Hell Maine ועוד.",
  ],

  "boss-together": [
    "אירועי בוס שיתופיים (I / II / III). אספו פארטי ועברו לשער האירוע כשהטיימר מגיע ל־Appeared / פתוח.",
  ],

  "arka-war": [
    "אירוע Arka War של גילדה מול גילדה. תאמו עם הגילדה שלכם לרישום ולחלונות הקרב.",
  ],

  "other-events": [
    "מתוזמנים גם: Invocation Demons, Merchant Zyro, Moss Merchant, TvT, Online Lottery, Custom Quiz, Custom Bonus ו־Custom Drop.",
    "פתחו את חלון Event Time במשחק או את דף Events באתר לספירות לאחור חיות.",
  ],
};

export default guidesParagraphsHe;
